'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isInteger = require('babel-runtime/core-js/number/is-integer');

var _isInteger2 = _interopRequireDefault(_isInteger);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeliveryPriceContainerController = function () {
  function DeliveryPriceContainerController($stateParams, lookupService, $q, loadingService, deliveryPriceManagementService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, DeliveryPriceContainerController);
    this.lookupService = lookupService;
    this.$stateParams = $stateParams;
    this.$q = $q;
    this.loadingService = loadingService;
    this.deliveryPriceManagementService = deliveryPriceManagementService;

    this.errMsg = '';
    this.deliveryPriceList = [];
    this.deliveryPrice = {};

    this.reset();
    this.init();
  }

  (0, _createClass3.default)(DeliveryPriceContainerController, [{
    key: 'reset',
    value: function reset() {
      this.deliveryPrice = {
        entityId: this.$stateParams.locationId,
        brandId: 1,
        brandModelId: null,
        price: null
      };

      this.errMsg = '';
    }
  }, {
    key: 'init',
    value: function init() {
      var ctrl = this;

      ctrl.loadingService.showLoading('container', 'Loading Delivery Prices');

      ctrl.initializeLookups().then(function () {
        ctrl.deliveryPriceManagementService.listDeliveryPrices(ctrl.$stateParams.locationId).then(function (response) {
          ctrl.deliveryPriceList = response.data.items;

          ctrl.loadingService.hideLoading('container');
        });
      });
    }
  }, {
    key: 'initializeLookups',
    value: function initializeLookups() {
      var _this = this;

      var ctrl = this;
      var deferred = this.$q.defer();

      this.lookupService.lookupBrands().then(function (brands) {
        _this.allBrands = brands;

        _this.lookupService.lookupBrandModels().then(function (brandModels) {
          _this.allBrandModels = brandModels;
          _this.updateBrandModel();

          deferred.resolve();
        });
      });

      return deferred.promise;
    }
  }, {
    key: 'add',
    value: function add() {
      var _this2 = this;

      if (!this.validateAdd()) {
        return;
      }

      this.loadingService.showLoading('container', 'Adding new Delivery Price ...');

      this.deliveryPriceManagementService.addDeliveryPrice(this.deliveryPrice).then(function (response) {
        _this2.reset();
        _this2.init();
        _this2.loadingService.hideLoading('container');
      });
    }
  }, {
    key: 'validateAdd',
    value: function validateAdd() {
      var _this3 = this;

      if (!this.deliveryPrice.price || !(0, _isInteger2.default)(parseInt(this.deliveryPrice.price))) {
        this.errMsg = 'Delivery Price must be a valid number';
        return false;
      }

      var dup = (0, _lodash.find)(this.deliveryPriceList, function (o) {
        return o.brandId === _this3.deliveryPrice.brandId && o.brandModelId == _this3.deliveryPrice.brandModelId;
      });

      if (dup) {
        this.errMsg = 'Delivery Price for ' + dup.brandName + ' ' + dup.brandModelName + ' already exists';
        return false;
      }

      return true;
    }
  }, {
    key: 'remove',
    value: function remove(deliveryPriceId) {
      var _this4 = this;

      var sure = window.confirm('Are you sure you want to remove this delivery price');

      if (!sure) {
        return;
      }
      this.loadingService.showLoading('container', 'Removing Delivery Price ...');

      this.deliveryPriceManagementService.removeDeliveryPrice(this.$stateParams.locationId, deliveryPriceId).then(function (response) {
        _this4.init();
        _this4.loadingService.hideLoading('container');
      });
    }
  }, {
    key: 'updateBrandModel',
    value: function updateBrandModel() {
      var _this5 = this;

      this.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
        return o.brandId === _this5.deliveryPrice.brandId;
      });
      this.brandModels.unshift({ brandModelId: null, name: 'All' });
    }
  }]);
  return DeliveryPriceContainerController;
}();

exports.default = DeliveryPriceContainerController;


// WEBPACK FOOTER //
// ./client/app/components/admin/deliveryPriceManagement/deliveryPriceContainer/deliveryPriceContainer.controller.js